import { useContext, useEffect } from 'react'
import { LateCancelsWrapper } from 'src/modules/cancellation-policy/containers'
import { LoadingWrapperContext } from 'src/modules/core/context'
import { PaginationProvider } from 'src/modules/core/providers'

export function LateCancels() {
  const { disableLoading } = useContext(LoadingWrapperContext)

  useEffect(() => {
    disableLoading()
  }, [disableLoading])

  return (
    <PaginationProvider>
      <LateCancelsWrapper />
    </PaginationProvider>
  )
}
